import { DateTime } from 'luxon'

export const limitString = (text: string, maxCharacters: number): string => {
  if (text.length <= maxCharacters) {
    return text
  } else {
    return text.substring(0, maxCharacters) + '...'
  }
}

export const dateFormater = (date: string): string => {
  return DateTime.fromISO(date).toFormat('dd.MM.yyyy')
}

export const hideCustomerName = (name: string): string => {
  return name.charAt(0) + '*'.repeat(name.length - 1)
}
